import { property, supertypeClass } from '@haventech/amorphic';
import { CoverpathBaseApplication } from '../coverpath_subclasses/CoverpathBaseApplication';
import { MMDirectPolicy } from './MMDirectPolicy';
import _ from 'lodash';
import { ApplicationSourceType } from '../../../common/js/customer/Application';
import { POLICY_TYPES } from '../../../common/js/constants/policy';

@supertypeClass({ toClient: true, toServer: true })
export class MMDirectApplication extends CoverpathBaseApplication {
  @property({ type: Array, getType: () => MMDirectPolicy })
  policies: Array<MMDirectPolicy> = [];

  init(customer) {
    super.init(customer);
    return this;
  }

  static new(customer) {
    return new MMDirectApplication().init(customer);
  }

  public getApplicationType() {
    return MMDirectApplication;
  }

  get primaryPolicy(): MMDirectPolicy {
    return (this.policies || []).reduce((priPol, pol) => {
      return priPol || (pol.isPrimary ? pol : null);
    }, null);
  }

  get secondaryPolicy(): MMDirectPolicy {
    return _.find(this.policies, (policy) => {
      return policy.type === POLICY_TYPES.SECONDARY;
    });
  }

  get primaryPolicyWithPendingAmendment(): MMDirectPolicy {
    return this.primaryPolicy;
  }

  addPolicy(policy: MMDirectPolicy) {
    super.addPolicy(policy as MMDirectPolicy);
  }

  addSecondaryPolicy(policy: MMDirectPolicy) {
    super.addPolicy(policy as MMDirectPolicy);
  }

  async cloneApplicationInSession(
    sourceType: ApplicationSourceType,
    newProgress?: number
  ): Promise<MMDirectApplication> {
    return super.cloneApplicationInSession(sourceType, newProgress) as Promise<MMDirectApplication>;
  }
}
